/**
 * Organization Switcher Module
 * Handles organization switching functionality for multiple switchers.
 */

export function initOrgSwitcher(switcherElement) {
    if (!switcherElement || switcherElement.dataset.initialized) {
        return;
    }
    switcherElement.dataset.initialized = 'true';

    const button = switcherElement.querySelector('button');
    const menu = switcherElement.querySelector('ul');

    if (!button || !menu) {
        return;
    }

    function toggleDropdown(event) {
        event.stopPropagation();
        const isHidden = menu.classList.contains('hidden');
        if (isHidden) {
            menu.classList.remove('hidden');
            button.setAttribute('aria-expanded', 'true');
        } else {
            menu.classList.add('hidden');
            button.setAttribute('aria-expanded', 'false');
        }
    }

    function closeDropdown() {
        menu.classList.add('hidden');
        button.setAttribute('aria-expanded', 'false');
    }

    button.addEventListener('click', toggleDropdown);

    document.addEventListener('click', (event) => {
        if (!switcherElement.contains(event.target)) {
            closeDropdown();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    });
    
    menu.addEventListener('click', function(e) {
        if (e.target.tagName === 'A' || e.target.closest('a')) {
            closeDropdown();
        }
    });
}

export function init() {
    const switchers = document.querySelectorAll('.relative[id*="-org-switcher"]');
    switchers.forEach(initOrgSwitcher);
}

// Reinitialize after HTMX swaps content
document.body.addEventListener('htmx:afterSwap', function() {
    init();
});
